module.exports = __webpack_public_path__ + "static/media/dole.9912dcb4.png";